import request from '@/utils/request.js'

export function addDemandIssue(data) {
  return request({
    url: '/bus/demands',
    method: 'POST',
    data
  })
}

export function editDemandInfos(data) {
  return request({
    url: '/bus/demands',
    method: 'PUT',
    data
  })
}

